import React, {Component} from 'react';
// import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Grid, Row, Col } from 'react-flexbox-grid';
// import { createStore } from 'redux';
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import LocationListContainer from './containers/LocationListContainer';
import ForecastExtendedContainer from './containers/ForecastExtendedContainer';
// import {setCity} from './actions';
// import{ store } from './store';
import './App.css';


const cities = [
    'Santiago,scl',
    'Buenos Aires,ar',
    'Bogota,col',
    'Ciudad de México,mx',
    'Madrid,es',
    'Rio de Janeiro,br',
    'London,uk'
];

// const store = createStore(() => {});

// const store = createStore(() => {}, window.__REDUX_DEVTOOLS_EXTENSION__&& window.__REDUX_DEVTOOLS_EXTENSION__());

// const setCity = value => ({
//   type: 'setCity',
//   value})

class App extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     city: null
  //   }
  // }

// handlerSelectionLocation = city => {
//   this.setState({city})
//   console.log(`handlerSelectionLocation ${city}`);

//   // const action = {type:'setState' , value: city}

//   // store.dispatch(action);
 
//   // store.dispatch(setCity(city));

//   this.props.setCity(city);
  
// }

  render() {
    return (
      <MuiThemeProvider>
        <Grid>
          <Row>
            <Col xs={12} md={12}>
              <AppBar title='weather'/>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6}>
            <LocationListContainer cities={cities}/>
            </Col>
            <Col xs={12} md={6}>
              <Paper zDepth={4}>
                <div className="details">
                  <ForecastExtendedContainer>
                  </ForecastExtendedContainer>
                </div>
              </Paper>
            </Col>
          </Row>
        </Grid>
      </MuiThemeProvider>

      /*
      <MuiThemeProvider>
        <div className="App">
        </div>
      </MuiThemeProvider>
      */
    );
  }
}

// const mapDispatchToPropsActions = () => {};
// const componentConnected = connect(null, mapDispatchToPropsActions)(App)

// App.propTypes = {
//   setCity: PropTypes.func.isRequiered,
// }

// const mapDispatchToPropsActions = dispatch => ({
//   setCity: value => dispatch(setCity(value))
  
// });

// const AppConnected = connect(null, mapDispatchToPropsActions)(App)

// export default AppConnected;

// export default connect(null, mapDispatchToPropsActions)(App)

export default App;


// WEBPACK FOOTER //
// ./src/App.js